




















































































































































import { Component, Vue } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import {
  paymentBehaviour,
  hasBeenChased,
  PaymentBehaviour,
  IPaymentBehaviourRow,
} from '@/app/customer-payment-behaviour';
import gql from 'graphql-tag';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ReportRow = IPaymentBehaviourRow & Record<string, any>;

const CUSTOMER_PAYMENT_BEHAVIOUR_REPORT = gql`
  query customerPaymentBehaviourReport($unitId: ID!, $from: Date!, $to: Date!) {
    customerPaymentBehaviourReport(unitId: $unitId, from: $from, to: $to) {
      customer {
        id
        unofficialName
        unit {
          id
          name
        }
      }
      invoicesCount
      invoicedAmount
      paidCount
      paidOnTimeCount
      paidLateCount
      unpaidCount
      overdueCount
      overdueAmount
      averageDaysLate
      maxDaysLate
      longestOverdueDays
      remindersCount
      interestChargesCount
    }
  }
`;

@Component
export default class CustomerPaymentBehaviourList extends Vue {
  @SmartQuery(CURRENT_UNIT) private currentUnit!: GQL_currentUnit_currentUnit;

  // A year back is long enough to show a habit and short enough that a
  // customer who has since improved is not judged on ancient history.
  private from = this.$dayjs().subtract(1, 'year').format('YYYY-MM-DD');
  private to = this.$dayjs().format('YYYY-MM-DD');

  @SmartQuery<CustomerPaymentBehaviourList>({
    query: () => CUSTOMER_PAYMENT_BEHAVIOUR_REPORT,
    variables() {
      return { unitId: this.currentUnit.id, from: this.from, to: this.to };
    },
    skip() {
      return !this.currentUnit?.id;
    },
    update: data => data.customerPaymentBehaviourReport,
  }) private rows!: ReportRow[];

  private customerName(row: ReportRow): string {
    const customer = row.customer;
    const name = customer.unit.name;

    return customer.unofficialName ? `${name}, ${customer.unofficialName}` : name;
  }

  private behaviourOf(row: ReportRow): PaymentBehaviour {
    return paymentBehaviour(row);
  }

  private chased(row: ReportRow): boolean {
    return hasBeenChased(row);
  }
}
